if (!customElements.get('wls-buybox')) {
    class WLSBuybox extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                activeClass: 'is-active',
                main: 'js-wls-buybox-main',
                nav: 'js-wls-buybox-nav',
                item: 'js-wls-buybox-main-item',
                stickyCta: 'js-wls-buybox-sticky-cta',
            };

            this.elements = {
                main: this.querySelector(`.${this.classes.main}`),
                nav: this.querySelector(`.${this.classes.nav}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
                stickyCta: this.querySelector(`.${this.classes.stickyCta}`),
            };

            this.checkVisibility = this.checkVisibility.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;
            this.init();
            window.addEventListener('scroll', this.checkVisibility);
            this.checkVisibility();
        }

        disconnectedCallback() {
            this.destroy();
            window.removeEventListener('scroll', this.checkVisibility);
        }

        checkIfEmpty() {
            if (!this.elements.main || !this.elements.items.length) {
                this.style.display = 'none';
                return true;
            }
            return false;
        }

        init() {
            this.initializeFlickity();
        }

        initializeFlickity() {
            this.flktyMain = new Flickity(this.elements.main, {
                cellSelector: '.js-wls-buybox-main-item',
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: true,
                draggable: true,
                imagesLoaded: true,
            });
        
            if (this.elements.nav) {
                this.flktyNav = new Flickity(this.elements.nav, {
                    cellSelector: '.carousel-cell',
                    asNavFor: this.elements.main,
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                    cellAlign: 'left',
                    draggable: true,
                });
            }

            this.flktyNav.on('staticClick', (event, pointer, cellElement, cellIndex) => {
                if (typeof cellIndex === 'number') {
                    this.flktyMain.select(cellIndex);
                }
            });
    
            this.flktyMain.on('change', (index) => {
                this.flktyNav.select(index);
            });
        }

        destroy() {
            if (this.flktyMain) {
                this.flktyMain.destroy();
                this.flktyMain = null;
            }

            if (this.flktyNav) {
                this.flktyNav.destroy();
                this.flktyNav = null;
            }
        }

        checkVisibility() {
            if (!this.elements.stickyCta) return;
            let shouldHide = false;
            const hideOnSectionIds = this.getAttribute('data-hide-on-section-ids');
            
            if (hideOnSectionIds) {
                const sectionIds = hideOnSectionIds.split(',').map(id => id.trim());
                
                sectionIds.forEach((sectionId) => {
                    const section = document.getElementById(sectionId);
                    if (section) {
                        const rect = section.getBoundingClientRect();
                        
                        if (rect.top < window.innerHeight && rect.bottom > 0) {
                            shouldHide = true;
                        }
                    }
                });
            }

            if (shouldHide) {
                this.elements.stickyCta.classList.remove(this.classes.activeClass);
            } else {
                this.elements.stickyCta.classList.add(this.classes.activeClass);
            }
        }
    }

    customElements.define('wls-buybox', WLSBuybox);
}